<template>

  <div class="corretiva-grupo ml-4 mr-4" >
      <b-form>          
          <b-row>
              <!-- -->


              <b-col cols="1">
                <br>
                <b-button variant="warning" class="ml-5 mt-2" v-b-modal.modal-multi-grupo @click="reset()">Novo</b-button>
              </b-col>

          </b-row>
    </b-form>

    
    <div class="d-flex justify-content-center mb-3">      
    </div>    
    <!--tbl de dados -->
    <b-table id="grupo"  small hover striped sticky-header="550px"  :items="grupo" :fields="fields" >    
        <template slot="cell(actions)" slot-scope="data"  >
          <b-button  @click="editGrupo(data.item)"    title="Editar Grupo"  size="sm" variant="primary" class="mr-2 mt-2" v-b-modal.modal-multi-grupo>                
            <i class="fa fa-exclamation-circle"></i>              
          </b-button> 
        </template>   
    </b-table>

      <!--  MODAL GRAVAÇÃO RELACAO DA GRUPO CORRETIVA -->
      <!--  MODAL GRAVAÇÃO RELACAO DA GRUPO CORRETIVA -->
      <div>        
    <b-modal id="modal-multi-grupo"   hide-footer size="lg" title="Cadastro de Grupos">
          <!-- -->
          <div>

            <b-row>
              <b-col cols="9">
                <label for="input-live">Grupo</label>
                <b-form-input v-model="grup.grupo" placeholder="Digite a descrição do grupo"></b-form-input>              
              </b-col>
          
          </b-row>  
          <input  id="id-grupo" type="hidden" v-model="grupo.id_grupo" />
         
             <b-button class="mt-3" variant="success" block @click="postGrupo(),reset()">Gravar</b-button>            
          </div>          
        </b-modal>
      </div>
      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
  </div>  
</template>


<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import moment from 'moment'




export default {    
    name: 'Manutencaogrupo',    

    data: function() {

        
      
        return {                        
            carregando: false,
            
                    
            grup:{},
            grupo: [],   // [] lista                        
            
          //  barra_inicial: 0,         
          //  barra_limite: 300000,
            
            fields: [
                { key: 'id_grupo', label: 'Id', sortable: true },     
                { key: 'grupo', label: 'Grupo', sortable: true },                                 
                
                { key: 'dt_cadastro', label: 'Data Cadastro', sortable: true, formatter: (value, key, grupo) => {
                    return moment(grupo.dt_cadastro).format('DD/MM/YYYY - HH:mm').replace('Data inválida','-') ; }  },

                { key: 'dt_alteracao', label: 'Data Alteracao', sortable: true, formatter: (value, key, grupo) => {
                    return moment(grupo.dt_alteracao).format('DD/MM/YYYY - HH:mm').replace('Data inválida','-') ; }  },

                { key: 'actions', label: 'Ações' },
                
            ]
        }        
    },

    components: {
        
    },
    methods: {


        loadGrupo() {          
          const url = `${baseApiUrl}/manutencao/corretiva/grupo`
          axios.get(url).then(res => {
            this.carregando = false;       
            this.grupo = res.data.map(grup => {              
              return { ... grup}
            })
          })
        },  






        editGrupo(grup){
            this.grup = { ...grup }
        },

          
        postGrupo() {                        
        let corpo = {                 
                "id_grupo": `${this.grup.id_grupo}`,
                "grupo": `${this.grup.grupo}`
        };

        const url = `${baseApiUrl}/manutencao/corretiva/grupo`   

            axios.post(url,corpo).then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset() //limpar os objetos valores
                })
                .catch(showError)
        },

        reset() {  
            this.grup = {}          
            this.grupo = []
            this.loadGrupo()            
        }
       
    },



    mounted() {                        
        this.loadGrupo()    //    se habilitado carrega o grid        
    },



}

</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>

#selecaostatusx{
    font-size: 0.7em;      
}

#grupos{   
    font-size: 0.9em;      
    text-align: center;
    
}




</style>